/* import __COLOCATED_TEMPLATE__ from './d-modal-cancel.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();